/* @flow */

import * as React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: any,
  className?: string
};

const Main = styled.div(({ theme }) => ({
  lineHeight: '38px',
  position: 'relative',
  overflow: 'hidden',
  color: '#ff0053',
  background: '#fff',
  textAlign: 'center',
  borderRadius: 2,
  display: 'inline-block',
  textTransform: 'uppercase',
  transition: 'color, background 0.5s ease-in-out',
  '&:hover': {
    color: '#ffffff',
    backgroundColor: '#ff0053',
    '& > :first-of-type': {
      transition: 'all 0.5s ease-in-out',
      transform: 'translateX(calc(100% + 9em))'
    }
  },
  [theme.mediaQuery.mobileOnly]: {
    lineHeight: '25px'
  }
}));

const SweepWrapper = styled.div({
  width: '100%',
  height: '100%',
  transform: 'translateX(0%)',
  display: 'block',
  position: 'absolute',
  top: 0,
  left: '-4.5em'
});

const Sweep = styled.div({
  pointerEvents: 'none',
  backgroundColor: 'rgba(255, 255, 255, 0.5)',
  height: '100%',
  width: '3em',
  transform: 'skewX(-45deg) translateX(0)'
});

class LightSweepButton extends React.Component {
  props: Props;

  static defaultProps = {
    className: undefined
  };

  render() {
    const { children, className } = this.props;
    return (
      <Main className={className}>
        <SweepWrapper>
          <Sweep />
        </SweepWrapper>
        {children}
      </Main>
    );
  }
}

export default LightSweepButton;
